import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["landing", "phoneInput", "thankYou", "phoneDisplay", "submitButton"];
  static values = {
    contactFormId: Number,
    contactListId: Number,
    contactsUrl: String,
  };

  connect() {
    this.digits = "";
    this.submitting = false;
    this.updateSubmitButton();
    this.applyZoom();
    this.boundApplyZoom = () => this.applyZoom();
    window.addEventListener("resize", this.boundApplyZoom);
  }

  disconnect() {
    window.removeEventListener("resize", this.boundApplyZoom);
  }

  showPhoneInput() {
    this.landingTarget.classList.add("hidden");
    this.phoneInputTarget.classList.remove("hidden");
    this.thankYouTarget.classList.add("hidden");
  }

  appendDigit(event) {
    if (this.digits.length >= 10) return;

    const digit = event.currentTarget.dataset.digit;
    this.digits += digit;
    this.updateDisplay();
  }

  backspace() {
    this.digits = this.digits.slice(0, -1);
    this.updateDisplay();
  }

  clear() {
    this.digits = "";
    this.updateDisplay();
  }

  async submit() {
    if (this.submitting || this.digits.length !== 10) return;

    this.submitting = true;
    this.submitButtonTarget.disabled = true;

    const formattedPhone = `(${this.digits.slice(0, 3)})${this.digits.slice(3, 6)}-${this.digits.slice(6)}`;

    const formData = new FormData();
    formData.append("contact[phone]", formattedPhone);
    formData.append("contact[contact_form_id]", this.contactFormIdValue);
    formData.append("contact[contact_list_id]", this.contactListIdValue);
    formData.append("contact[has_opted_in_to_communication]", "true");
    formData.append("contact[has_opted_in_to_marketing_sms]", "true");
    formData.append("contact[has_opted_in_to_account_notification_sms]", "true");
    formData.append("contact[parent_url]", window.location.href);

    try {
      await fetch(this.contactsUrlValue, {
        method: "POST",
        headers: { "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content },
        body: formData,
        redirect: "manual",
      });
    } catch {
      // Silently swallow errors — kiosk should always feel successful
    }

    this.showThankYou();
  }

  showThankYou() {
    this.landingTarget.classList.add("hidden");
    this.phoneInputTarget.classList.add("hidden");
    this.thankYouTarget.classList.remove("hidden");

    setTimeout(() => this.reset(), 3000);
  }

  reset() {
    this.digits = "";
    this.submitting = false;
    this.updateDisplay();

    this.landingTarget.classList.remove("hidden");
    this.phoneInputTarget.classList.add("hidden");
    this.thankYouTarget.classList.add("hidden");
  }

  updateDisplay() {
    const d = this.digits;
    let formatted = "";
    if (d.length > 0) formatted += "(" + d.slice(0, 3);
    if (d.length >= 3) formatted += ")";
    if (d.length > 3) formatted += d.slice(3, 6);
    if (d.length > 6) formatted += "-" + d.slice(6);
    this.phoneDisplayTarget.value = formatted;
    this.updateSubmitButton();
  }

  updateSubmitButton() {
    this.submitButtonTarget.disabled = this.digits.length !== 10;
  }

  applyZoom() {
    const scale = Math.min(window.innerWidth / 560, window.innerHeight / 800);
    this.element.style.zoom = scale;
    this.element.style.minHeight = `${window.innerHeight / scale}px`;
  }
}
